import {
  EXTENDED_SUBSCRIPTION_PAGE_SIZE,
  NEGOTIATIONS_SUBSCRIPTION_PAGE_SIZE,
  STAGING_SUBSCRIPTION_PAGE_SIZE,
  SubscriptionIdentifier,
  SUBSCRIPTION_PAGE_SIZE
} from 'api'

export function getPageSize(subscriptionIdentifier: SubscriptionIdentifier) {
  const subscriptionIdToPageSize: Record<SubscriptionIdentifier, number> = {
    [SubscriptionIdentifier.BLOTTER]: EXTENDED_SUBSCRIPTION_PAGE_SIZE,
    [SubscriptionIdentifier.DEAL_INTEREST_PERIOD]: SUBSCRIPTION_PAGE_SIZE,
    [SubscriptionIdentifier.DEAL_HISTORY]: SUBSCRIPTION_PAGE_SIZE,
    [SubscriptionIdentifier.HISTORICAL]: SUBSCRIPTION_PAGE_SIZE,
    [SubscriptionIdentifier.HISTORICAL_MID_TRADE_EVENTS]: SUBSCRIPTION_PAGE_SIZE,
    [SubscriptionIdentifier.HISTORY]: SUBSCRIPTION_PAGE_SIZE,
    [SubscriptionIdentifier.INCOMING]: NEGOTIATIONS_SUBSCRIPTION_PAGE_SIZE,
    [SubscriptionIdentifier.INCOMING_TERMINATED_NOTIFICATION]: SUBSCRIPTION_PAGE_SIZE,
    [SubscriptionIdentifier.INITIATED]: NEGOTIATIONS_SUBSCRIPTION_PAGE_SIZE,
    [SubscriptionIdentifier.INITIATED_GRID_VIEW]: NEGOTIATIONS_SUBSCRIPTION_PAGE_SIZE,
    [SubscriptionIdentifier.INITIATED_TERMINATED_NOTIFICATION]: SUBSCRIPTION_PAGE_SIZE,
    [SubscriptionIdentifier.LATEST]: SUBSCRIPTION_PAGE_SIZE,
    [SubscriptionIdentifier.MTE_UPLOAD]: SUBSCRIPTION_PAGE_SIZE,
    [SubscriptionIdentifier.MID_TRADE_EVENT]: SUBSCRIPTION_PAGE_SIZE,
    [SubscriptionIdentifier.OPEN_REPO]: SUBSCRIPTION_PAGE_SIZE,
    [SubscriptionIdentifier.STRUCTURED]: SUBSCRIPTION_PAGE_SIZE,
    [SubscriptionIdentifier.STAGING]: STAGING_SUBSCRIPTION_PAGE_SIZE,
    [SubscriptionIdentifier.AXE_TODAY_RESPONDER]: SUBSCRIPTION_PAGE_SIZE,
    [SubscriptionIdentifier.AXE_TODAY_INITIATOR]: SUBSCRIPTION_PAGE_SIZE,
    [SubscriptionIdentifier.ROLLS]: SUBSCRIPTION_PAGE_SIZE,
    [SubscriptionIdentifier.COLLATERAL_DETAILS]: SUBSCRIPTION_PAGE_SIZE
  }

  return subscriptionIdToPageSize[subscriptionIdentifier]
}
